import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { includedItems, PRICE, BOOK_TITLE, BOOK_SUBTITLE } from '../data/content';
export function Offer() {
  return <section className="border-b border-carbon-800 bg-carbon-900 py-20 sm:py-24" id="oferta" data-id="element-62" data-mp="1mplgpqx1ewg0">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-63" data-mp="1hqiox862impz">
        <div className="mx-auto max-w-2xl text-center" data-id="element-64" data-mp="tzwgvgw2d2fz">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-volt" data-id="element-65" data-mp="u0oaim63oq3m">La oferta</p>
          <h2 className="mt-4 text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl" data-id="element-66" data-mp="p24qwsezbqef">
            Un solo libro. Todo el diagnóstico.
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mt-12 overflow-hidden rounded-2xl border border-carbon-700 bg-carbon-850 shadow-[0_40px_90px_-40px_rgba(0,0,0,0.9)]" data-id="element-67" data-mp="ywmyw9rfi841">
          <div className="grid md:grid-cols-[minmax(0,0.6fr)_minmax(0,1fr)]" data-id="element-68" data-mp="ui90kb2nusn1">
            <div className="border-b border-carbon-700 bg-carbon-800 p-6 md:border-b-0 md:border-r md:p-8" data-id="element-69" data-mp="zhvdskiho8vu">
              <div className="overflow-hidden rounded-lg border border-carbon-700 shadow-xl" data-id="element-70" data-mp="13k9v306if0l0">
                <img src="https://cdn.magicpatterns.com/uploads/q5W6RzGhSKT3ZTRgGEHiFW/Screenshot_2026-08-01_at_7.22.43_PM.png" alt={`Portada del eBook ${BOOK_TITLE}`} className="h-full w-full object-cover" data-id="element-71" data-mp="6uiow3ouvozd" />
              </div>
              <h3 className="mt-6 text-base font-bold leading-snug tracking-tight text-white" data-id="element-72" data-mp="kle19pykco7p">
                {BOOK_TITLE}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-slate-400" data-id="element-73" data-mp="3k8doh3gm4zrw">{BOOK_SUBTITLE}</p>
            </div>

            <div className="flex flex-col justify-between p-8 sm:p-10" data-id="element-74" data-mp="3o84kpmows83t">
              <ul className="space-y-4" data-id="element-75" data-mp="ve624bcshrtt">
                {includedItems.map(item => <li key={item.label} className="flex gap-3" data-id="element-76" data-mp="qfurhyeo7daj">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-77" data-mp="155agb8un58nl" />
                    <div data-id="element-78" data-mp="108jz2i73o70l">
                      <p className="text-sm font-semibold text-white" data-id="element-79" data-mp="cgmo0tbh5j0j">{item.label}</p>
                      <p className="text-xs text-slate-400" data-id="element-80" data-mp="7hryl8j04w7g">{item.note}</p>
                    </div>
                  </li>)}
              </ul>

              <div className="mt-10 border-t border-carbon-700 pt-8" data-id="element-81" data-mp="lj4btc6s2jpn">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500" data-id="element-82" data-mp="hfpu8h36xva3">
                  Pago único
                </p>
                <p className="mt-2 text-5xl font-black tracking-tight text-white" data-id="element-83" data-mp="1wyt14a7i7utm">{PRICE}</p>
                <p className="mt-2 text-sm text-slate-400" data-id="element-84" data-mp="1suv2s1q06o1m">
                  Sin suscripciones. Sin cobros recurrentes.
                </p>

                <CtaButton label="Obtener mi copia ahora" className="mt-6 w-full" data-id="element-85" data-mp="25e9ugkiw2ww3" />

                <p className="mt-4 flex items-center justify-center gap-2 text-xs text-slate-500" data-id="element-86" data-mp="1qghiu3ggqsn6">
                  <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-87" data-mp="1vfkp1r86j4wq" />
                  Compra protegida por Hotmart
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}